import { format } from 'date-fns';

export const dateToScheduleFormat = (date: Date) => format(date, 'yyyy-MM-dd');

/**
 * Note that schedule dates are returned like '2024-12-09T00:00:00' - without timezone or "Z",
 * so we have to use substring here. Otherwise, we will shoot ourselves in the foot with local time zone shifts.
 */
export const substrDateFromAirtableFormat = (date: string) => {
  return date.substring(0, 10);
};
